import React from 'react'

export const ScrapeContext = React.createContext();

export const ScrapeProvider = ScrapeContext.Provider;
